import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface LoginResponse {
    token: string;
    loginSuccess: boolean;
    message: string;
    captchaResponse: string;
}

export interface LogoutResponse {
    message: string;
}

export interface UserDetailsResponse {
    userName: string;
    firstName: string;
    lastName: string;
    userType: string;
    employeeId: number | null;
    residentId: number | null;
    userId: number;
    zoneIds: number[];
    departments: number[];
    mobileNumber: string;
    email: string;
    rank: string;
}

export interface OtpRequestVo {
    userName: string;
    mobileNumber: string;
    email: string | null;
    otp: string | null;
    source: string | null;
    captchaResponse: string | null;
}

export interface OtpResponse {
    success: boolean;
    message: string;
    cooldownTime: number;
    maskedEmail: string;
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private http: HttpClient) { }

    // GET request
    get<T>(endpoint: string, params?: any): Observable<T> {
        const httpParams = new HttpParams({ fromObject: params });
        return this.http.get<T>(endpoint, { params: httpParams });
    }

    loginUser(body: any): Observable<LoginResponse> {
        return this.http.post<LoginResponse>('/auth/v1/login', body);
    }

    // GET request
    getUserInfo(): Observable<UserDetailsResponse> {
        return this.http.get<UserDetailsResponse>('/auth/v1/userInfo');
    }

    logoutUser(): Observable<LogoutResponse> {
        return this.http.get<LogoutResponse>('/auth/v1/logout');
    }

    verifyUserAndRequestOtp(body: OtpRequestVo): Observable<OtpResponse> {
        return this.http.post<OtpResponse>('/public/v1/request-otp', body);
    }

    validateRequestedOtp(body: OtpRequestVo): Observable<LoginResponse> {
        return this.http.post<LoginResponse>('/public/v1/validate-otp', body);
    }
}
